function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "information") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M105.063 207h1.875v-6.25h-1.875zm.932-8.125a.92.92 0 0 0 .67-.268.893.893 0 0 0 .273-.664.92.92 0 0 0-.268-.67.893.893 0 0 0-.664-.273.92.92 0 0 0-.67.268.893.893 0 0 0-.273.664.92.92 0 0 0 .268.67.893.893 0 0 0 .664.273zm.012 13.125a9.764 9.764 0 0 1-3.887-.781 10.044 10.044 0 0 1-5.339-5.337 10.062 10.062 0 0 1 0-7.775 10.079 10.079 0 0 1 5.337-5.326 10.062 10.062 0 0 1 7.775 0 10.1 10.1 0 0 1 5.326 5.331 10.044 10.044 0 0 1 0 7.768 10.061 10.061 0 0 1-5.331 5.339 9.712 9.712 0 0 1-3.881.781z",
    transform: "translate(-94 -190)",
    style: {
      fill: "#21a2ee"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information_icon.aea0375f47ce3305043572c99e61c870.svg";
export { ForwardRef as ReactComponent };